import { LanguageEnum } from '@/enums/language.enum';

export default () => {
  return {
    locale: [],
    languages: Object.values(LanguageEnum),
  }
}
